export default "__VITE_ASSET__Bsxt398i__"